<template>
    <div>
        <a-page-header
            style="border: 1px solid rgb(235, 237, 240)"
            :ghost="false"
            title="Report"
            :sub-title="title"
            @back="back">

            <common-training-header :withLocation="true"/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-skeleton :loading="loading" active>
                <a-table class="pcp-table" :dataSource="items.user_scores" rowKey="hash" :pagination="false" bordered>

                    <a-table-column :width="50" key="number" title="No" className="align-center text-small text-left">
                        <h3 slot-scope="t,r,i" class="text-center">
                            {{ i + 1 }}
                        </h3>
                    </a-table-column>

                    <a-table-column :width="100" key="photo" title="Foto" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <div style="text-align: center">
                                <img :src="record.photo" v-if="record.photo != null" height="50" />
                                <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                            </div>
                        </template>
                    </a-table-column>

                    <a-table-column key="attendant" title="Nama" className="align-center text-small">
                        <template slot-scope="record">'
                            <h3>
                                <a-icon type="user" /> {{ record.name }} <br>
                                <a-icon type="mail" /> {{ record.email }}
                            </h3>
                        </template>
                    </a-table-column>

                    <a-table-column :width="350" key="position" title="Posisi / Asal" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <h3>{{ record.position }}</h3>
                        </template>
                    </a-table-column>

                    <a-table-column-group v-for="penilai in 3" :key="penilai">
                        <span slot="title">Penilaian {{ penilai }}</span>

                        <a-table-column v-for="(aspect) in items.aspects" :key="aspect.hash+'_'+penilai" className="text-center">
                            <span slot="title" :class="module != 'project' ? '' : 'orientation'">{{ toPascalCase(aspect.name) }}</span>

                            <template slot-scope="record">
                                <h3 v-if="hasEvaluator(getIndexObjActivity(record.activities, aspect.code)[penilai])">
                                    {{ parseFloat(currentAspect(getIndexObjActivity(record.activities, aspect.code)[penilai], aspect.code).raw_score).toFixed(2) }}
                                </h3>
                            </template>
                        </a-table-column>
                    </a-table-column-group>

                    <a-table-column-group v-if="module != 'project'">
                        <span slot="title">Total Nilai</span>

                        <a-table-column v-for="(aspect) in items.aspects" :key="aspect.hash" :title="toPascalCase(aspect.name) + ' ' + (aspect.weight * 100) + '%'" className="text-center">
                            <template slot-scope="record">
                                <h3>{{ parseFloat(record.activities[0].total[aspect.name.replace(/\s*MAKALAH\s*/ig,'').replace(/teknik\s*/ig,'').toLowerCase()]).toFixed(2) }}</h3>
                            </template>
                        </a-table-column>
                    </a-table-column-group>

                    <a-table-column key="result" title="Nilai Akhir" className="text-center">
                        <template slot-scope="record">
                            <h3 v-if="record.module_scores.length > 0">
                                {{ parseFloat(record.module_scores[0].paper_score).toFixed(2) }}
                            </h3>
                        </template>
                    </a-table-column>
                </a-table>
            </a-skeleton>
        </a-card>
    </div>
</template>


<script>
export default {
    props: {
        module: {
            type: String,
            default: 'paper'
        }
    },
    data() {
        return {
            loading: false,
            items: {}
        }
    },
    computed: {
        title(){
            switch(this.module) {
                case "evaluation":
                    return "Akhir Evaluasi Kinerja"
                case "project":
                    return "Report Nilai Project Management"
                default:
                    return "Rekap Penilaian Makalah"
            }
        },
        width(){
            switch(this.module) {
                case "evaluation":
                    return "50%"
                case "project":
                    return "50%"
                default:
                    return "50%"
            }
        },
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true
            let uri = this.routeUri('api.report.paper.detail')

            switch (this.module) {
                case 'evaluation':
                    uri = this.routeUri('api.report.evaluation.detail')
                    break;
                case 'project':
                    uri = this.routeUri('api.report.project.detail')
                    break;
                default:
                    uri = this.routeUri('api.report.paper.detail')
                    break;
            }

            this.$http.get(uri)
                .then(response => {this.items = response.data})
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        hasEvaluator(evaluator) {
            return typeof(evaluator) == 'object' ? true : false
        },
        currentAspect(evaluatorScores, aspectCode){
            let evaluator = {}

            evaluatorScores.forEach((item) => {
                if(item.code == aspectCode){
                    evaluator = item
                }
            })

            return evaluator
        },
        getIndexObjActivity(activities, aspectCode) {
            let evaluator = {}

            activities.forEach(activity => {
                if((aspectCode == 'PRJ-PRO' || aspectCode == 'PRJ-PRE') && !activity.is_proposal){
                    //project management
                    if(!Array.isArray(activity.evaluator_score)){
                        evaluator = activity.evaluator_score
                    }
                }else if((aspectCode == 'PRJ-IMP' || aspectCode == 'PRJ-FOU' || aspectCode == 'PRJ-EVA') && activity.is_proposal){
                    //project management
                    if(!Array.isArray(activity.evaluator_score)){
                        evaluator = activity.evaluator_score
                    }
                }else{
                    //paper
                    if(!Array.isArray(activity.evaluator_score)){
                        evaluator = activity.evaluator_score
                    }
                }
            })
            return evaluator
        },
        toPascalCase(string){
            return string.replace(/\s*MAKALAH\s*/ig,'').replace(/(\w)(\w*)/g, function(g0,g1,g2){
                return g1.toUpperCase() + g2.toLowerCase()
            })
        },
        back() {
            window.location.href = this.routeUri('admin.classical.general.report')
        }
    },
}
</script>


<style lang="less">
.orientation {
    writing-mode: vertical-rl;
    text-orientation: mixed;
}
</style>
